import { formatCurrency } from '@/modules/_helpers/formatCurrency'

/**
 * A unit price of the checkout: whole amounts without cents ("20 €"), others as usual ("9,90 €").
 * Sums and totals keep their cents and use formatCurrency directly.
 */
const formatPrice = (value: number): string => Number.isInteger(value)
  ? formatCurrency(value, { precision: 0 })
  : formatCurrency(value)

export default formatPrice
